import { groupBy } from 'lodash';
import { ElasticSearchSortInterface } from '../../core/elasticsearch/model/elastic-search-sort.interface';
import { SortByType } from '../model/sort-by.type';

export function categoryFiltersToSearchQuery(activeFilters: any[], nestedPath: string): any[] {
  const queryFilters: any[] = [];
  const groupedFilters = groupBy(activeFilters, 'name');

  Object.entries(groupedFilters).forEach((filterGroup: any) => {
    const filters = filterGroup[1].map((filter: any) => {
      return {
        nested: {
          query: {
            bool: {
              filter: [
                {
                  term: {
                    [`${nestedPath}.sName.keyword`]: {
                      value: filter.name,
                    },
                  },
                },
                {
                  terms: {
                    [`${nestedPath}.sValue.keyword`]: [filter.value],
                  },
                },
              ],
            },
          },
          path: nestedPath,
        },
      };
    });
    queryFilters.push({
      bool: {
        should: [...filters],
      },
    });
  });
  return queryFilters;
}

export function buildCategoryFacetedMultiSearchQuery(
  sUrlPath: string,
  queryFilters: any[],
  size = 12,
  page = 0,
  sortBy: SortByType | ElasticSearchSortInterface[] = 'relevance',
  articleIndex: string,
  categoryIndex: string,
  exclude: string[] = [],
) {
  const sort = Array.isArray(sortBy) ? sortBy : sortBy === 'title' ? [{ 'sTitle.keyword': 'asc' }] : [];

  return [
    { index: articleIndex },
    {
      size: 0,
      aggs: {
        agg_full: {
          filter: {
            bool: {
              must: [
                {
                  bool: {
                    must: [
                      {
                        prefix: {
                          'sUrlPath.keyword': sUrlPath,
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          aggs: {
            article_count: {
              terms: {
                size: 100000,
                field: 'oProductInfo.lngGroup',
              },
            },
            filtered: {
              nested: {
                path: 'oFeatures',
              },
              aggs: {
                attr_name: {
                  terms: {
                    size: 1000,
                    field: 'oFeatures.sName.keyword',
                  },
                  aggs: {
                    feature: {
                      top_hits: {
                        size: 1,
                        _source: {
                          include: ['oFeatures.shtRepresentationType', 'oFeatures.shtWebshopFilter'],
                        },
                      },
                    },
                    attr_value: {
                      terms: {
                        size: 1000,
                        field: 'oFeatures.sValue.keyword',
                      },
                      aggs: {
                        option: {
                          top_hits: {
                            size: 1,
                            _source: {
                              include: ['oFeatures.shtPos'],
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
        agg_filtered: {
          filter: {
            bool: {
              must: [
                {
                  bool: {
                    must: [
                      {
                        prefix: {
                          'sUrlPath.keyword': sUrlPath,
                        },
                      },
                    ],
                  },
                },
                ...categoryFiltersToSearchQuery(queryFilters, 'oFeatures'),
              ],
            },
          },
          aggs: {
            article_count: {
              terms: {
                size: 100000,
                field: 'oProductInfo.lngGroup',
              },
              aggs: {
                article: {
                  top_hits: {
                    size: 1,
                    _source: {
                      include: ['sArticleID'],
                    },
                  },
                },
              },
            },
            filtered: {
              nested: {
                path: 'oFeatures',
              },
              aggs: {
                attr_name: {
                  terms: {
                    size: 1000,
                    field: 'oFeatures.sName.keyword',
                  },
                  aggs: {
                    attr_value: {
                      terms: {
                        size: 1000,
                        field: 'oFeatures.sValue.keyword',
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
    { index: categoryIndex },
    {
      from: page,
      size: size,
      sort: sort,
      _source: { exclude },
      post_filter: {
        bool: {
          filter: {
            bool: {
              must: [
                {
                  prefix: {
                    'sUrlPath.keyword': sUrlPath,
                  },
                },
                { term: { 'sType.keyword': 'P' } },
                ...categoryFiltersToSearchQuery(queryFilters, 'oArticles.oFeatures'),
              ],
            },
          },
        },
      },
    },
    { index: categoryIndex },
    {
      size: 1,
      query: {
        bool: {
          filter: {
            term: {
              'sUrlPath.keyword': sUrlPath,
            },
          },
        },
      },
    },
  ];
}
